



























import { Vue, Component } from "vue-property-decorator";
import ProductDetail from "@/components/cutomer/productDetail.vue";
import QPaginate from "@/common/qPaginate.vue";
import QProductPopup from "@/common/qProductPopup.vue";
import { namespace } from "vuex-class";
import qNotify from "@/common/qNotify";
import { ADMIN_TYPE } from "../../../common/constant";
const cartStore = namespace("Cart");
const authStore = namespace("Auth");
@Component({
  name: "QGoToOrder",
  components: {
    ProductDetail,
    QPaginate,
    QProductPopup,
  },
})
export default class QGoToOrder extends Vue {
  @cartStore.Getter
  cartItems!: any[];

  @authStore.Getter
  getUserType!: string;

  public gotoOrder() {
    if (this.cartItems.length > 0) {
      this.$router.push({ name: "customer.order" });
    } else {
      qNotify.error({
        text: this.$t("cart_page.messsage.empty_cart"),
      });
    }
  }

  get showOrderButton() {
    return this.$route.name == 'front.home' && this.getUserType != ADMIN_TYPE;
  }
}
